// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"_2dc5f59","title":"_b8eb362","hasSubtitle":"_60da643","subtitle":"_7e3235d","content":"_c12b1a2"};